module.exports = __webpack_public_path__ + "img/couples-024.c5edca43.jpg";